export default {
  modficationmasse: {
    status: {
      valide: 'La modification de masse a été réalisée',
    },
  },
};
